import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MessageService } from "primeng/api";
import { debounceTime } from "rxjs/operators";
import { HttpService } from "../../services/http.service";
import { StateService } from "../../services/state.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-share-experiment",
  templateUrl: "./share-experiment.component.html",
  styleUrls: ["./share-experiment.component.scss"],
})
export class ShareExperimentComponent implements OnInit {
  @Input() selectedExperiment: any;
  @Input() isActionFromStudio: boolean = false;
  @Input() hasMultipleShareAction: boolean = false;
  @Output() closeSharePopup: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  mailIdList: any[] = [];
  suggestions: any[] = [];
  searchText: any = "";
  visible: boolean = true;
  userID: any;
  allowEditing: boolean = true;
  shareLoader: boolean = false;
  invalidEmail: boolean = false;
  expID: any;
  sharedUsers: any[] = [];
  sharedWithClicked: boolean = false;
  removeShareLoader: boolean = false;
  sharedUserIDTobeRemoved: any;
  optionsList = [
    { name: this.translate.instant("PRODUCT_HEADER.VIEW"), value: "view" },
    { name: this.translate.instant("PRODUCT_SIDEBAR.EDIT"), value: "edit" },
    { name: this.translate.instant("PRODUCT_HEADER.REMOVE"), value: "remove" },
  ];
  domainType: string = "";

  // For multiple share action
  @Input() multipleSelectedData: any[] = []; // For multiple share action
  @Output() bulkShareActionEmit = new EventEmitter<any>();

  @Input() isActionFromParent: boolean = false; // To identify the action is from parent component or not
  @Input() isAllUsersAllowed: boolean = false; // To identify the user is not key account user
  @Output() shareActionEmit = new EventEmitter<any>();

  constructor(
    private stateService: StateService,
    private httpService: HttpService,
    private messageService: MessageService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.domainType = sessionStorage.getItem("domainType") || "";
  }

  ngOnChanges(changes: SimpleChanges) {
    // If multiple share action is enabled, get the shared users for each selected experiment
    if (
      changes.hasMultipleShareAction &&
      changes.hasMultipleShareAction.currentValue
    ) {
      this.hasMultipleShareAction =
        changes.hasMultipleShareAction.currentValue || false;
      this.sharedUsers = [];
      this.sharedWithClicked = false;

      this.multipleSelectedData.forEach((experiment) => {
        if (experiment) {
          if (!experiment.hasOwnProperty("shared_users")) {
            experiment.shared_users = [];
          }
          this.getSharedUsersList(experiment);
        }
      });
    }
    if (changes.selectedExperiment && changes.selectedExperiment.currentValue) {
      this.expID = changes.selectedExperiment.currentValue.id;
      this.selectedExperiment = changes.selectedExperiment.currentValue;
      if (!this.selectedExperiment.hasOwnProperty("shared_users")) {
        this.selectedExperiment.shared_users = [];
      }
      this.getSharedUsersList(changes.selectedExperiment.currentValue);
    }

    if (changes.isAllUsersAllowed && changes["isAllUsersAllowed"]) {
      this.isAllUsersAllowed = changes.isAllUsersAllowed.currentValue || false;
    }
  }

  closeDialog() {
    this.mailIdList = [];
    this.closeSharePopup.emit(true);
    this.searchText = "";
    this.sharedWithClicked = false;
    this.isActionFromStudio = false;
    this.hasMultipleShareAction = false;
  }

  getUserSuggestions(event: any) {
    this.getUserDetail();
    this.getUserFromServer();
    this.searchText = event.query;
  }

  getUserDetail() {
    this.userID = null;
    if (!this.searchText.length) {
      this.mailIdList = [];
    }
  }

  getUserFromServer() {
    let key_acc_id: any = null;
    let exclude_id: any = null;
    if (!this.hasMultipleShareAction && !this.isAllUsersAllowed) {
      key_acc_id = this.selectedExperiment.key_account_id
        ? this.selectedExperiment.key_account_id
        : sessionStorage.getItem("expKeyAccountId");
      exclude_id =
        this.selectedExperiment.created_by || this.selectedExperiment.user;
    }
    const url = `${this.stateService.apiList.user.searchUserV3}?search=${this.searchText}&key_account_id=${key_acc_id}`;
    this.httpService
      .getMethod(url)
      .pipe(debounceTime(500))
      .subscribe(
        (val: any) => {
          this.mailIdList = val
            .filter((each: any) => {
              return (
                !this.selectedExperiment?.shared_users?.includes(each.id) &&
                exclude_id != each.id
              );
            })
            .map((each: any) => {
              each.name = [each.first_name, each.last_name]
                .filter((name) => name)
                .join(" ");
              each.has_key_account_access =
                key_acc_id == "Other" ? true : each.has_key_account_access;
              return each;
            });
          this.suggestions = this.mailIdList;
        },
        (err: any) => {
          if (err.status === 400) {
          } else if (err.status !== 401) {
            this.messageService.clear();
            this.messageService.add({
              key: "c",
              severity: "warn",
              summary: err.error.message,
              detail: err.error.traceback,
            });
          }
          this.stateService.removeCalledApi(url);
        }
      );
  }

  shareInvite() {
    let validEmail = false;
    let selectedItem: any;
    for (let item of this.mailIdList) {
      if (item.email === this.searchText.email) {
        this.userID = item.id;
        validEmail = true;
        selectedItem = item;
        break;
      }
    }

    if (!validEmail) {
      this.invalidEmail = true;
      return;
    }

    // Code to handle the action from parent component (Dashboard)
    if (this.isActionFromParent) {
      const userPayload = {
        user_id: this.userID,
        access_type: this.allowEditing ? "edit" : "read",
      };
      this.shareLoader = true;
      const data = {
        payload: userPayload,
        userData: selectedItem,
      };
      this.shareActionEmit.emit({data});
      return;
    }

    // If multiple share action is enabled, emit the user payload to the parent component(StudioComponent)
    if (this.hasMultipleShareAction) {
      const userPayload = {
        user_id: this.userID,
        access_type: this.allowEditing ? "edit" : "read",
      };
      this.bulkShareActionEmit.emit(userPayload);
      this.closeDialog();
      return;
    }

    // If share loader is not active, proceed with the share action
    if (!this.shareLoader) {
      this.shareLoader = true;

      // Check if the selected experiment is a folder or not
      if (this.selectedExperiment.experiment_type !== "folder") {
        // If not a folder, call the shareExperimentApiCall method
        this.shareExperimentApiCall(selectedItem);
      } else {
        // If it is a folder, call the shareFloderApiCall method
        this.shareFloderApiCall(selectedItem);
      }
    }
  }

  // Share the experiment to the selected user Api call
  shareExperimentApiCall(selectedItem: any) {
    const url = `${this.stateService.apiList.experiments.getExperiments}/${this.expID}/share/${this.userID}`;
    const payload = {
      experiment_id: this.expID,
      user_id: this.userID,
      share_type: this.allowEditing ? "edit" : "read",
    };
    this.commonApiCall(
      url,
      "postMethod",
      payload,
      (response: any, params: any) => {
        if (response) {
          this.getCallbackSharedUserResponse(selectedItem);
        }
      }
    );
  }

  // Helper method to callback the shared user response
  getCallbackSharedUserResponse(selectedItem: any) {
    if (this.isActionFromStudio) {
      this.showSuccessToast("Shared successfully");
    } else {
      this.messageService.add({
        key: "s",
        severity: "success",
        summary: "Shared successfully",
        detail: "Success",
      });
    }
    this.selectedExperiment.shared_users.push(selectedItem.id);
    this.updateSharedUsersList(selectedItem);
  }

  // Helper method to update the shared user list in the UI
  updateSharedUsersList(selectedItem: any) {
    this.searchText = "";
    const firstname = selectedItem.name
      ? selectedItem.name.split(" ")[0]
      : selectedItem.first_name;
    const lastname = selectedItem.name
      ? selectedItem.name.split(" ")[1]
      : selectedItem.last_name;
    selectedItem.first_name = firstname;
    selectedItem.last_name = lastname;
    selectedItem.permission = this.allowEditing ? "edit" : "read";
    if (this.sharedUsers) {
      this.sharedUsers.push(selectedItem);
      this.selectedExperiment.shared_users_data = this.sharedUsers;
    }
    this.shareLoader = false;
  }

  getSharedUsersList(experiment: any) {
    if (experiment.shared_users_data || !experiment.shared_users.length) {
      if (this.hasMultipleShareAction) {
        this.sharedUsers.push(
          ...(experiment.shared_users.length
            ? experiment.shared_users_data.map((user: any) => {
                return user;
              })
            : [])
        );
      } else {
        this.sharedUsers = experiment.shared_users.length
          ? experiment.shared_users_data
          : [];
      }
      this.sharedWithClicked = true;
      return;
    }

    const payload = {
      users_list: experiment.shared_users.map((user: any) => user.id),
    };

    this.stateService.getBulkUserDetailsService(payload).subscribe(
      (val: any) => {
        if (val) {
          experiment.shared_users_data = val;
          experiment.shared_users_data.map((user: any) => {
            const index = experiment.shared_users.findIndex(
              (user1: any) => user1.id === user.id
            );

            user["permission"] = experiment.shared_users[index].access;
          });
          if (this.hasMultipleShareAction) {
            if (!Array.isArray(this.sharedUsers)) {
              this.sharedUsers = [];
            }
            this.sharedUsers.push(
              ...experiment.shared_users_data.map((user: any) => {
                return user;
              })
            );
          } else {
            this.sharedUsers = experiment.shared_users_data;
          }
          this.sharedWithClicked = true;
        }
      },
      (err: any) => {
        if (err.status === 400) {
          this.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Warn Message",
            detail: err.error.message,
          });
        } else if (err.status !== 401) {
          this.messageService.clear();
          this.messageService.add({
            key: "c",
            severity: "warn",
            summary: err.error.message,
            detail: err.error.traceback,
          });
        }
      }
    );
    if (!this.hasMultipleShareAction) {
      this.showInvite(experiment);
    }
  }

  showInvite(experiment: any) {
    this.invalidEmail = false;
    this.userID = experiment.user;
    this.expID = experiment.id;
    this.selectedExperiment = experiment;
    this.sharedUsers = experiment.shared_users_data;
  }

  getColor(index: number) {
    let colors = ["#FFDBDB", "#E2DBFF", "#DBF5FF", "#DBE2FF"];
    return colors[index % 4];
  }

  hasValidValue(str: any) {
    return !!str && str.toLowerCase() !== "none";
  }

  // User actions permissions like edit read or remove
  sharedUserActions(userID: string, event: any, item: any) {
    // Code to handle the action from parent component (Dashboard)
    if (this.isActionFromParent) {
      const userPayload: any = {
        user_id: userID,
      };

      if (event.value !== "remove") {
        userPayload["access_type"] = event.value === "edit" ? "edit" : "read";
      } else {
        this.removeShareLoader = true;
        this.sharedUserIDTobeRemoved = userID;
      }

      const data = {
        payload: userPayload,
      };

      this.shareActionEmit.emit({data, isEdit: true});
      return;
    }

    if (this.isNotFolderType) {
      this.sharedExperimentUserActions(userID, event);
    } else {
      this.sharedFolderUserActions(userID, event);
    }
  }

  // Update the experiment access to the selected user Api call
  sharedExperimentUserActions(userID: string, event: any) {
    switch (event.value) {
      case "edit":
        const url = `${this.stateService.apiList.experiments.getExperiments}/${this.expID}/share/${userID}`;
        const payload = {
          share_type: "edit",
        };

        this.httpService.putMethod(url, payload).subscribe((val: any) => {});

        break;
      case "view":
        const permissionUrl = `${this.stateService.apiList.experiments.getExperiments}/${this.expID}/share/${userID}`;
        const data = {
          share_type: "read",
        };

        this.httpService
          .putMethod(permissionUrl, data)
          .subscribe((val: any) => {});
        break;
      case "remove":
        this.sharedUserIDTobeRemoved = userID;
        if (!this.removeShareLoader) {
          this.removeShareLoader = true;
          const url = `${this.stateService.apiList.experiments.getExperiments}/${this.expID}/share/${userID}`;
          this.httpService.deleteMethod(url).subscribe(
            (val: any) => {
              this.getCallbackRemovedUserResponse(userID);
            },
            (err: any) => {
              this.sharedUserIDTobeRemoved = null;
              this.removeShareLoader = false;
              if (err.status === 400) {
                this.messageService.add({
                  key: "w",
                  severity: "warn",
                  summary: "Warn Message",
                  detail: err.error.message.message,
                });
              } else if (err.status !== 401) {
                this.messageService.clear();
                this.messageService.add({
                  key: "c",
                  severity: "warn",
                  summary: err.error.message,
                  detail: err.error.traceback,
                });
              }
            }
          );
        }
        break;
      default:
        break;
    }
  }

  // Helper method to removed user from shared user list once Api call success
  getCallbackRemovedUserResponse(userID: string) {
    this.updateRemovedUserList(userID);

    if (this.isActionFromStudio) {
      this.showSuccessToast("Share access removed successfully");
    } else {
      this.messageService.add({
        key: "s",
        severity: "success",
        summary: "Share access removed successfully",
        detail: "Success",
      });
    }
  }

  // Helper method to update the shared user list in the UI after removing the user
  updateRemovedUserList(userID: string) {
    if (this.sharedUsers) {
      // Remove the user from the shared_users
      for (let i = 0; i <= this.sharedUsers.length; i++) {
        if (this.sharedUsers[i].id === userID) {
          this.sharedUsers.splice(i, 1);
          break;
        }
      }
    }

    let currentUsers = this.selectedExperiment.shared_users;
    for (let i = 0; i <= currentUsers.length; i++) {
      if (currentUsers[i] === userID) {
        currentUsers.splice(i, 1);
        break;
      }
    }

    this.selectedExperiment.shared_users = currentUsers;
    this.removeShareLoader = false;
    this.sharedUserIDTobeRemoved = null;
  }

  // Function to share the folder to the selected user Api call
  shareFloderApiCall(selectedItem: any) {
    const url = `${this.stateService.apiList.experiments.shareAndUpdateFolder(this.expID)}`;
    const payload = {
      user_id: this.userID,
      access_type: this.allowEditing ? "edit" : "read",
    };
    this.commonApiCall(
      url,
      "postMethod",
      payload,
      (response: any, params: any) => {
        if (response) {
          this.getCallbackSharedUserResponse(selectedItem);
        }
      }
    );
  }

  // Function to update the user access and revoked the user for selected floder
  sharedFolderUserActions(userID: string, event: any) {
    const url = `${this.stateService.apiList.experiments.shareAndUpdateFolder(this.expID)}`;
    switch (event.value) {
      case "edit":
      case "view":
        const payload = {
          user_id: userID,
          access_type: event.value === "edit" ? "edit" : "read",
        };
        this.httpService.patchMethod(url, payload).subscribe((val: any) => {});
        break;

      case "remove":
        this.sharedUserIDTobeRemoved = userID;
        if (!this.removeShareLoader) {
          this.removeShareLoader = true;
          const payload = {
            user_id: userID,
          };

          this.commonApiCall(
            url,
            "deleteMethod",
            payload,
            (response: any, params: any) => {
              this.getCallbackRemovedUserResponse(userID);
            }
          );
        }
        break;
      default:
        break;
    }
  }

  get isNotFolderType() {
    return (
      this.selectedExperiment &&
      this.selectedExperiment?.experiment_type !== "folder"
    );
  }

  showSuccessToast(message: string) {
    this.messageService.clear();
    this.messageService.add({
      key: "sbc",
      severity: "success",
      summary: message,
      detail: "Success",
      life: 5000,
    });
  }

  showWarningToast(message: string) {
    this.messageService.clear();
    this.messageService.add({
      key: "wbc",
      severity: "warn",
      summary: message,
      detail: "Warning",
      life: 5000,
    });
  }

  // Function for Common Api call
  commonApiCall(
    apiUrl: string,
    method: "getMethod" | "postMethod" | "putMethod" | "deleteMethod",
    params: any,
    callback: (response: any, params: any) => void
  ) {
    this.httpService[method](apiUrl, params).subscribe(
      (response: any) => {
        // common callback function for response
        callback(response, params);
      },
      (err: any) => {
        console.error("Error in API call:", err);
        this.messageService.clear();
        if (err.status === 400) {
          this.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Something went wrong!",
            detail: err.error.message,
            sticky: true,
          });
        } else if (err.status === 422) {
          this.messageService.add({
            key: "w",
            severity: "warn",
            summary: err.error.detail[0].msg || "Something went wrong!",
            detail: err.error.detail,
            sticky: true,
          });
        } else if (err.status !== 401) {
          if (this.isActionFromStudio) {
            this.showWarningToast(err.error.message || "Something went wrong!");
          } else {
            this.messageService.add({
              key: "c",
              severity: "warn",
              summary: err.error.message || "Something went wrong!",
              detail: err.error.traceback,
              sticky: true,
            });
          }
        }
        this.searchText = "";
        this.shareLoader = false;
        this.removeShareLoader = false;
      }
    );
  }
}
